// extracted by mini-css-extract-plugin
export var carrierIcon = "_w8-0";
export var carrierLogo = "_w8-1";
export var detailsSection = "_w8-2";